export const events = {
  CREATE_PROJECT_STARTED: 'uf.project.create.started',
  CREATE_PROJECT_SUCCESS: 'uf.project.create.success',
  CREATE_PROJECT_FAILURE: 'uf.project.create.failure',
  PROJECT_SELECTED: 'uf.project.selected',
  PROJECT_CANVAS_INFORMATION: 'uf.project.canvas_information',
  PROJECT_DELETE: 'uf.project.delete',
};
